import { css } from 'emotion'
import { Colors } from './..'
import { Easings } from '../core';

export const ProgressBarStyle = (theme, x, big) => css({
  position: 'relative',
  display: 'block',
  width: '100%',
  height: big ? 6 : 3,
  background: Colors.extraLightGrey,
  zIndex: 1,
  overflow: 'hidden',
  '.progress-bar': {
    '&--inner': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: `${x}%`,
      height: '100%',
      background: Colors[theme],
      zIndex: 2,
      transform: 'scaleX(0)',
      transformOrigin: 'center left',
      animation: `progress2 200ms ${Easings.customEase} forwards 400ms`
    }
  },
  '@keyframes progress2': {
    '0%': {
      transform: 'scaleX(0)',
    },
    '100%': {
      transform: 'scaleX(1)',
    }
  },
})


// WEBPACK FOOTER //
// ./src/styles/components/progressBar.js